// extracted by mini-css-extract-plugin
export default {"preventScroll":"G15bed5","left":"Gcd6943 G061925","center":"G3df5a2 G41b766","right":"G4556e1 Gddfcfd"};